// export default function secondsToDhms(seconds) {
//   seconds = Number(seconds)
//   var d = Math.floor(seconds / (3600 * 24))
//   var h = Math.floor((seconds % (3600 * 24)) / 3600)
//   var m = Math.floor((seconds % 3600) / 60)
//   var s = Math.floor(seconds % 60)

//   var dDisplay = d > 0 ? d + (d == 1 ? ' day, ' : ' days, ') : ''
//   var hDisplay = h > 0 ? h + (h == 1 ? ' hour, ' : ' hours, ') : ''
//   var mDisplay = m > 0 ? m + (m == 1 ? ' minute, ' : ' minutes, ') : ''
//   var sDisplay = s > 0 ? s + (s == 1 ? ' second' : ' seconds') : ''
//   return dDisplay + hDisplay + mDisplay + sDisplay
// }

export default function toHHMMSS(sec_num) {
  // var sec_num = parseInt(this, 10); // don't forget the second param
  var hours = Math.floor(sec_num / 3600)
  var minutes = Math.floor((sec_num - hours * 3600) / 60)
  var seconds = sec_num - hours * 3600 - minutes * 60

  if (hours < 10) {
    hours = '0' + hours
  }
  if (minutes < 10) {
    minutes = '0' + minutes
  }
  if (seconds < 10) {
    seconds = '0' + seconds
  }
  return hours + ':' + minutes + ':' + seconds
}
